




























































import Vue from "vue";
import { API } from "aws-amplify";
import { Constants } from "@/api-constants";

export default Vue.extend({

  name: 'TeamInviteButton',


  components: {},

  props: {
    team: {
      type: Object,
      default:  () => {},
    },
  },

  data() {
    return {
      dialog: false,
      packageId: this.$store.getters.getPackageId,
      apiFunction: 'teams/{packageId}/{teamId}/share/link',
      shareLink: '',
      isUpdating: true,
    }
  },

  watch: {
    dialog(newVal, oldVal) {
      if (newVal) {
        this.shareLink = '';
      }
    },
  },

  computed: {
    getTeamId(): string {
      if (Object.keys(this.team).length) {
        return this.team.teamId;
      } else {
        return '';
      }
    },
    teamName(): string {
      if (Object.keys(this.team).length){
        let name: string  = ( this.team.name ? String(this.team.name) : '' );
        let res: string = ( name.length > 8 ? String(name.substring(0, 8)) + '...' : String(name) );
        return res;
      } else {
      return '';
      }
    },
  },

  methods: {

    async generateShareLink() {
      this.dialog = true;
      this.isUpdating = true;
      const path = this.apiFunction
        .replace('{packageId}', this.packageId)
        .replace('{teamId}', this.getTeamId);
      API.get(Constants.API_NAME, path, {})
        .then(response => {
          console.log('[ generateShareLink() RESPONSE ]: ');
          console.log(response);
          this.shareLink = this.constructShareLink(response.shareLinkCode);
        })
        .catch(error => {
          console.log('[ generateShareLink() ERROR ]: ');
          console.log(error);
        })
        .finally( () => {
          this.isUpdating = false;
          // setTimeout(() => this.showMessage = false, 1900);
          // setTimeout(() => this.dialog = false, 2000);
       });      
    },

    constructShareLink(shareCode: string): string {
      let localUrl: any = window.location.href;
      return localUrl + '/?shareCode=' + shareCode;
    },

  },

});
